import { createContext } from 'react';

import { ProcessContextReturnType } from '@p/audience/shared/process/types/context-return.type';

export const ProcessContext = createContext<ProcessContextReturnType | null>(null);
